var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-b border-dashed border-secondary-20 m-2",on:{"click":function($event){$event.stopPropagation();}}})}
var staticRenderFns = []

export { render, staticRenderFns }